"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _order = require("@/api/order");
var _cropUpload = _interopRequireDefault(require("@/components/cropUpload"));
var _default = {
  components: {
    cropUpload: _cropUpload.default
  },
  props: ['orderId'],
  data: function data() {
    return {
      form: {
        orderId: "",
        images: []
      },
      dialogVisible: false,
      rules: {
        images: [{
          required: true,
          message: '请上传用户收货凭证',
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    imgChange: function imgChange(val, type) {
      if (type === 'del') {
        this.form.images.splice(val, 1);
      } else {
        this.form.images.push(val);
      }
      this.$refs.cropUpload.sortList = this.form.images;
    },
    submit: function submit() {
      var _this = this;
      this.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          var params = (0, _objectSpread2.default)({}, _this.form);
          params.images = params.images.join(',');
          (0, _order.confirmGoods)(params).then(function (res) {
            _this.dialogVisible = false;
            _this.$emit('getList', true);
          });
        } else {
          _this.$message({
            message: "请检查表单错误",
            type: "error"
          });
          return false;
        }
      });
    }
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      if (val) {
        this.form.orderId = this.orderId;
        this.form.images = [];
      }
    }
  }
};
exports.default = _default;